import React, { Suspense, lazy, useEffect } from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { Home } from './pages/Home';
import { ScrollToTop } from './components/ScrollToTop';

// Unterseiten werden erst nach der Startseite geladen. Dadurch muss der Browser
// beim ersten Besuch deutlich weniger Code verarbeiten.
const loadAblauf = () => import('./pages/Ablauf');
const loadAboutMe = () => import('./pages/AboutMe');
const loadImpressum = () => import('./pages/Impressum');
const loadDatenschutz = () => import('./pages/Datenschutz');
const Ablauf = lazy(() => loadAblauf().then(m => ({
  default: m.Ablauf
})));
const AboutMe = lazy(() => loadAboutMe().then(m => ({
  default: m.AboutMe
})));
const Impressum = lazy(() => loadImpressum().then(m => ({
  default: m.Impressum
})));
const Datenschutz = lazy(() => loadDatenschutz().then(m => ({
  default: m.Datenschutz
})));

// Sobald die aktuelle Seite fertig ist, werden die Unterseiten und das Porträt
// von Tina im Hintergrund vorgeladen. Beim Klick auf "Über Tina" oder "Ablauf"
// ist dann alles schon da und die Seite erscheint sofort vollständig.
function usePrefetchSubpages() {
  useEffect(() => {
    let cancelled = false;
    const prefetch = () => {
      if (cancelled) return;
      loadAblauf();
      loadAboutMe().then(m => {
        if (cancelled) return;
        const img = new Image();
        img.decoding = 'async';
        img.src = m.portraitSrc;
      });
      loadImpressum();
      loadDatenschutz();
    };
    const start = () => {
      if ('requestIdleCallback' in window) {
        window.requestIdleCallback(prefetch, {
          timeout: 4000
        });
      } else {
        setTimeout(prefetch, 2000);
      }
    };
    if (document.readyState === 'complete') {
      start();
    } else {
      window.addEventListener('load', start, {
        once: true
      });
    }
    return () => {
      cancelled = true;
      window.removeEventListener('load', start);
    };
  }, []);
}
export function App() {
  usePrefetchSubpages();
  return <BrowserRouter data-id="element-0" data-mp="35oy8u9shaup">
      <ScrollToTop data-id="element-1" data-mp="356wxj89s6fx" />
      <Suspense fallback={<div className="min-h-screen w-full bg-cream" data-id="element-3" data-mp="3uct43lu76r1j" />} data-id="element-2" data-mp="38kwkjpju1jo">
        <Routes data-id="element-4" data-mp="3uc9km0owfule">
          <Route path="/" element={<Home data-id="element-6" data-mp="d4nvzht0nm2x" />} data-id="element-5" data-mp="3ucj8niqdvrog" />
          <Route path="/ablauf-der-hot-sales-girls-academy" element={<Ablauf data-id="element-8" data-mp="d2l7j27ii10b" />} data-id="element-7" data-mp="d57fh2ybeij2" />
          <Route path="/ueber-tina-xla" element={<AboutMe data-id="element-10" data-mp="86w6svjrae2f" />} data-id="element-9" data-mp="85ui3o9tht28" />
          {/* Weiterleitungen von den alten URLs, damit bestehende Links funktionieren */}
          <Route path="/ablauf" element={<Navigate to="/ablauf-der-hot-sales-girls-academy" replace data-id="element-12" data-mp="3gj1vqgs7dd7e" />} data-id="element-11" data-mp="3glwabrojc3sw" />
          <Route path="/about-me" element={<Navigate to="/ueber-tina-xla" replace data-id="element-14" data-mp="3qb7jfebf98gs" />} data-id="element-13" data-mp="3bo4kr4bd4trv" />
          <Route path="/impressum" element={<Impressum data-id="element-16" data-mp="3qd0ud5t2ieul" />} data-id="element-15" data-mp="3qcr0h74wjnjm" />
          <Route path="/datenschutz" element={<Datenschutz data-id="element-18" data-mp="3liwjwcklfoor" />} data-id="element-17" data-mp="3ljxu6etsc75f" />
        </Routes>
      </Suspense>
    </BrowserRouter>;
}